export const infoWrapper = "i9548cd";
export const iconContainer = "icxix52";
export const badgeTipWrapper = "b1be1h3a";
export const badgeTipCommunityContainer = "b11sjbsd";
export const badgeTipCommunityTitle = "b1kbh10z";
export const badgeTipEncoreContainer = "bozikqe";
export const badgeTipVideoContainer = "b12csahk";
export const badgeTipEncoreTitle = "bzn6sn1";
export const badgeTipVideoTitle = "b1a4wwtn";
export const badgeTipHeader = "b14vmzvs";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");